enum AudienceType {
  none = '',
  private = 'Private',
  professionalStaff = 'All',
  prefessionalStaffPeerAdvisors = 'FullNetwork',
  specificNetworkMembers = 'SpecificNetworkMembers',
}
export default AudienceType;
